import React from 'react';
import { Footer } from './footer';
import { Header } from './header';
import { Menu } from './menu';

interface Props {
  children?: React.ReactNode
}

export const Layout: React.FC<Props> = ({ children }: Props) => (
  <div className="flex flex-col min-h-screen">
    <div className="flex-1 flex flex-row">
      <aside className="min-w-[296px] border-r border-gray-medium">
        <Menu />
      </aside>
      <section className="flex-1 flex flex-col">
        <Header />
        <main className="flex-1 bg-white-dirty-lighter">
          {children}
        </main>
        <Footer />
      </section>
    </div>
  </div>
);

Layout.defaultProps = {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  children: <></>,
};
